import React from 'react';
import PropTypes from 'prop-types';
import DestructiveConfirmModal from '../../../shared/DestructiveConfirmModal';

const Tag = ({ children, brand }) => (
  <span
    className="mr-2 mb-1 d-inline-block"
    style={{
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '18px',
      padding: '2px 8px',
      borderRadius: 'var(--radius-sm)',
      background: 'var(--sl-bg-primary)',
      border: `1px solid ${brand ? 'var(--sl-border-brand)' : 'var(--sl-border-primary)'}`,
      color: brand ? 'var(--sl-text-brand)' : 'var(--sl-text-secondary)',
    }}
  >
    {children}
  </span>
);
Tag.propTypes = { children: PropTypes.node.isRequired, brand: PropTypes.bool };

const cardStyle = {
  background: 'var(--sl-bg-primary)',
  border: '1px solid var(--sl-border-secondary)',
  borderRadius: 'var(--radius-xl)',
  boxShadow: 'var(--sl-shadow-xs)',
};

const EventTemplateList = ({ eventTemplates, editingId, onEdit, onDelete, onNewTemplate, renderEditPanel }) => (
  <div className="card" style={cardStyle}>
    <div className="card-body">
      <div className="d-flex align-items-start justify-content-between mb-3">
        <div>
          <p className="mb-1" style={{ fontSize: '16px', color: 'var(--sl-text-primary)' }}><strong>Event Templates</strong></p>
          <p className="m-0 small" style={{ color: 'var(--sl-text-tertiary)' }}>
            Pair an offer template, a budget template and notes — then edit their details right here.
          </p>
        </div>
        <button type="button" className="team-btn-primary flex-shrink-0" onClick={onNewTemplate}>
          <i className="far fa-plus mr-2" />New Template
        </button>
      </div>

      <table className="mb-0 table table-borderless">
        <colgroup>
          <col style={{ width: '28%' }} /><col style={{ width: '36%' }} /><col style={{ width: '30%' }} /><col style={{ width: '6%' }} />
        </colgroup>
        <thead>
          <tr className="text-uppercase" style={{ fontSize: '12px', color: 'var(--sl-text-tertiary)' }}>
            <th>Name</th><th>Description</th><th>Contents</th><th />
          </tr>
        </thead>
        <tbody>
          {eventTemplates.map((et) => (
            <tr key={et.id} style={{ borderTop: '1px solid var(--sl-border-secondary)' }}>
              {et.id === editingId ? (
                <td colSpan="4" className="p-0">{renderEditPanel(et)}</td>
              ) : (
                <>
                  <td className="align-middle"><strong style={{ color: 'var(--sl-text-primary)' }}>{et.name}</strong></td>
                  <td className="align-middle" style={{ color: 'var(--sl-text-tertiary)' }}>{et.description}</td>
                  <td className="align-middle">
                    {et.v3_offer_template_name ? <Tag brand>{`Offer · ${et.v3_offer_template_name}`}</Tag> : null}
                    {et.v3_budget_template_name ? <Tag>{`Budget · ${et.v3_budget_template_name}`}</Tag> : null}
                    {et.age_restriction ? <Tag>{`Age · ${et.age_restriction}`}</Tag> : null}
                    {(et.notes || []).length > 0 ? <Tag>{`${et.notes.length} notes`}</Tag> : null}
                  </td>
                  <td className="align-middle text-right text-nowrap">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      style={{ color: 'var(--sl-text-quaternary)' }}
                      aria-label={`Edit ${et.name}`}
                      onClick={() => onEdit(et)}
                    >
                      <i className="far fa-pencil" aria-hidden="true" />
                    </button>
                    <DestructiveConfirmModal
                      trigger={(
                        <button
                          type="button"
                          className="btn btn-link p-0 ml-3"
                          style={{ color: 'var(--sl-text-quaternary)' }}
                          aria-label={`Delete ${et.name}`}
                        >
                          <i className="far fa-trash" aria-hidden="true" />
                        </button>
                      )}
                      title="Delete event template?"
                      body={<>This permanently deletes the <strong>{et.name}</strong> event template. This can’t be undone.</>}
                      confirmLabel="Delete"
                      onConfirm={() => onDelete(et)}
                    />
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

EventTemplateList.propTypes = {
  eventTemplates: PropTypes.array.isRequired,
  editingId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onNewTemplate: PropTypes.func.isRequired,
  renderEditPanel: PropTypes.func.isRequired,
};

export default EventTemplateList;
